<template>
  <div>
    <v-dialog v-model="personModal"  width="500">
      <v-form v-model="formValid" lazy-validation>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{thispersonName}}</v-card-title>

        <v-card-text>
          <div v-if='personType === "niece/nephew" || personType=== "paternal cousins" || personType=== "maternal cousins"'>
           <span>Who is {{thispersonName}}'s father or mother?</span>
           <v-select
            :rules='fieldRules'
            :placeholder="`Parents of ${thispersonName}`"
            v-model="selectedperson.parents"
            :items="parentsList()"
            required
          ></v-select>
          </div>
          <v-text-field
            @focus="$event.target.select()"
            v-model="selectedperson.name"
            :label="`${thispersonName}'s first name (optional)`"
          ></v-text-field>
          <span v-if='dataModel[indexTosave] && (dataModel[indexTosave].id === dataModel[indexTosave].name || dataModel[indexTosave].name === "" )'>Is {{formType[0]}} {{dataModel[indexTosave].id}} living?</span>
          <span v-else>Is {{thispersonName}} living?</span>
          <v-radio-group v-model="selectedperson.isLiving" true-value="true" false-value="false">
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>

          <v-text-field
            @focus="$event.target.select()"
            type="tel"
            pattern="[0-9]*"
            v-model="selectedperson.age"
            :label="ageText()"
            :rules='ageRules'
          ></v-text-field>
          <v-select
            :placeholder="`gender of ${thispersonName}`"
            v-model="selectedperson.gender"
            :items="genderList"
          ></v-select>

          <span v-if='dataModel[indexTosave] && (dataModel[indexTosave].id === dataModel[indexTosave].name || dataModel[indexTosave].name === "" )'>Has {{formType[0]}} {{dataModel[indexTosave].id}} ever been diagnosed with cancer?</span>
          <span v-else>Has {{thispersonName}} ever been diagnosed with cancer?</span>
          <Cancer v-if="indexTosave" :modifyIndex="indexTosave"/>
                    <span v-if='dataModel[indexTosave] && (dataModel[indexTosave].id === dataModel[indexTosave].name || dataModel[indexTosave].name === "" )'>Has {{formType[0]}} {{dataModel[indexTosave].id}} completed any genetic testing previously?</span>
          <span v-else>Has {{thispersonName}} completed any genetic testing previously?</span>
          <CancerTest v-if="indexTosave" :modifyIndex="indexTosave"/>
          <v-textarea v-model="selectedperson.notes" outline name="input-7-4" label="Notes (optional)" value></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!formValid" color="primary" text @click="personModal = false,save()">Save</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>

    <v-card-text>
      <v-form v-model="formValid" lazy-validation>
      <v-text-field
        @focus="$event.target.select()"
        required
        :rules='addPersonRule'
        v-model="personNum"
        type="number"
        :min='inputMin'
        :max='inputMax'
        :disabled='this.sibNum === 0 && (personType === "niece/nephew" || personType=== "paternal cousins" || personType=== "maternal cousins" )'
        
      ></v-text-field>
        </v-form>
      <span v-if="personNum > 0">Click on each {{personType}} below to add details.</span>
      <div v-if="dataModel.length !== 0">
        <template v-for="(person,index) in dataModel">
          <template v-if="person.relationship === personType">
            <v-chip
              @click="personModal = true,setSelected(person)"
              v-bind:key="index"
              color="light blue"
              text-color="white"
            >
              <v-avatar>
                <v-icon>account_circle</v-icon>
              </v-avatar>
              <template v-if="dataModel[index].name === '' ">{{dataModel[index].id}}</template>
              <template v-else>{{dataModel[index].name}}</template>
            </v-chip>
          </template>
        </template>
      </div>
    </v-card-text>
  </div>
</template>

<script>

import { mapFields } from "vuex-map-fields";
import Cancer from "./Cancer.vue";
import CancerTest from "./CancerTest.vue";
export default {
  props: {
    personType: String,
    sibNum : Number,
    formType: Array
  },
  components: {
    Cancer,
    CancerTest,
  },
  data: () => ({
    inputMin : 0,
    inputMax : 15,
    indexTosave: null,
    personNum: 0,
    personModal: false,
    selectedperson: {
      id: "",
      age: 0,
      name: "",
      gender: null,
      isLiving: true,
      notes: ""
    },
     fieldRules: [v => !!v || "this field is required"],
     ageRules: [v => (v && v >= 0) || 'Age must be larger or equal to 0'],
     addPersonRule : [v => (v && v >= 0) || "this field is required"]
  }),

  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
      "snackbar",
      "errorText",
      "genderList",
      "formValid"
    ]),
    thispersonName() {
      if (this.selectedperson.name === "") {
        return this.selectedperson.id;
      } else {
        return this.selectedperson.name;
      }
    }
  },
  watch : {
    personNum : function(newval){
          if(newval > 15){
            return 0
          }
          this.dataModel = this.dataModel.filter(item => {
        return item.relationship !== this.personType;
      });
      for (var i = 0; i < newval; i++) {
        var genderDefault = "Gender variant/non-conforming";
        switch (this.personType) {
          case "maternal grandmother":
          case "maternal aunt":
            genderDefault = "Female";
            break;
          case "maternal grandfather":
          case "maternal uncle":
            genderDefault = "Male";
            break;
          default:
            break;
        }
        this.dataModel.push({
          relationship: this.personType,
          name: this.personType + [i + 1],
          gender: genderDefault,
          isLiving: true,
          age: 0,
          isgeneTest: "No",
          isCancer: false,
          cancerConditions: [],
          cancerConditionsDx: {},
          geneTestDetail: {
            geneName: "",
            mutationName: "",
            labName: ""
          },
          cancerOther: "",
          notes: "",
          id: this.personType + [i + 1]
        });
      }
    },
  },
  methods: {
    parentsList(){
      let pList
      switch(this.personType){
        
        case "paternal cousins":
         pList = this.dataModel.filter(item => {return item.relationship === "paternal uncle" || item.relationship === "paternal aunt"}).map(function(obj){return obj.name});
        return pList
         case "maternal cousins":
         pList = this.dataModel.filter(item => {return item.relationship === "maternal uncle" || item.relationship === "maternal aunt"}).map(function(obj){return obj.name});
        return pList
        case "niece/nephew" : 
         pList = this.dataModel.filter(item => {return item.relationship === "sibling"}).map(function(obj){return obj.name});
      return pList


      }

     
    },
    ageText() {
      if (this.selectedperson.isLiving) {
        return "What is " + this.thispersonName + "'s age?";
      } else {
        return "What is " + this.thispersonName + "'s age of passing?";
      }
    },
    save() {
      if (this.indexTosave === -1) {
        this.dataModel.push(this.selectedperson);
      } else {
        this.dataModel[this.indexTosave] = this.selectedperson;
      }
      this.dataModel[this.indexTosave] = this.selectedperson;
    },
    setSelected(person) {
      this.selectedperson = person;
      this.indexTosave = this.dataModel.findIndex(item => {
        return item.id === this.selectedperson.id;
      });
    },
  }
};
</script>
